import React, { useState } from 'react';

//components material mui
import {
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
    LinearProgress
} from '@mui/material';


//compnents
import { DialogoBoostrap } from './DialogoPersonalizado/DialogoBoostrap';

//context user
import { useGlobalState } from '../../Utilidades/useGlobalState';

//styles
import { modalesMensajesGenericos } from '../Tool/Style';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

let funcionCargarModal;
let validaCargaModal;
let funcionLoadingModal;

export const DialogoMostrarMensaje = ({ deviceIs = "DESKTOP", TextoMostrar, funcionAceptar = undefined }) => {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const [loading, setLoading] = useState(false);// se encarga del cargando del modal

    const { etiquetas } = useGlobalState();

    const [cargaConfirmar, setCargaConfirmar] = useState(false);
    funcionCargarModal = setCargaConfirmar;
    validaCargaModal = cargaConfirmar;
    funcionLoadingModal = setLoading;

    return (
        <DialogoBoostrap
            onClose={mostrarDialogoMostrarMensaje}
            aria-labelledby="customized-dialog-title"
            open={cargaConfirmar}
            fullScreen={fullScreen}
            maxWidth="sm"
            sx={deviceIs === "MOBILE" ? { margin:"6px", height:  "256px", top:'32%'}: undefined}
            fullWidth>
            {loading ? <LinearProgress></LinearProgress> : null}
            <DialogTitle>
                {etiquetas.General.Et_TituloDialogoMensaje}
            </DialogTitle>
            <DialogContent dividers style={{ backgroundColor: modalesMensajesGenericos.BotonesNo.backgroundColor }}>
                {TextoMostrar}
            </DialogContent>
            <DialogActions style={{ justifyContent: 'right', margin: '5px' }} >
                <Button
                    disabled={loading}
                    style={modalesMensajesGenericos.BotonesOk}
                    variant="outlined"
                    onClick={() => {
                        setLoading(true);
                        if (funcionAceptar !== undefined)
                            funcionAceptar();
                        setLoading(false);
                        mostrarDialogoMostrarMensaje();
                    }}
                >{etiquetas.General.Et_tbnAceptar}
                </Button>                
            </DialogActions>
        </DialogoBoostrap>
    );
}

export const mostrarDialogoMostrarMensaje = () => {
    funcionCargarModal(!validaCargaModal);
    if (validaCargaModal === false) {
        funcionLoadingModal(false);
    }
}